'use strict'
import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM.js';

export class MyAccountSettings{
    #settingsContainer
    constructor(){
        this.#settingsContainer = DOM.el('.my-account-settings-container');
        if(this.#settingsContainer){
            this.#handleProfileButton()
        }
    }


    #handleProfileButton(){
        const profilePictureWrapper = DOM.el('.profile-picture-wrapper', this.#settingsContainer);
        const profilePicture = DOM.el('img', profilePictureWrapper);
        const fileInput = DOM.el('input[type="file"]', profilePictureWrapper)
        const button = DOM.el('.profile-picture-upload-button', profilePictureWrapper);

        DOM.addEvent('click', button, (event) => {
            event.preventDefault()
            fileInput?.click();
        })

        DOM.addEvent('change', fileInput, () => {
            const file = fileInput.files[0];
            console.log(file);
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    profilePicture.src = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        });
    }
}